/**
 * 综合绩效考核表 动态分类 用于判断是否是新版动态分类，跳转新旧页面用
 */
export default {
  data() {
    return {
      isDynamicEffective: true,
    }
  },
  methods: {
    getDynamicClassify({year, period}) {
      const param = {year: year ? parseInt(year) : undefined, period: period || undefined}
      this.$ajax.post(this.$api.period.yearWeight.getClassify, param).then((res) => {
        const classifys = res.data || []
        this.isDynamicEffective = classifys.length > 0;
        return classifys;
      })
    },
  },
}